import { put, call, takeEvery } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import {
  accessoryConfigSuccess,
  accessoryConfigFailure,
  accessoryConfigUpdateSuccess,
  accessoryConfigUpdateFailure,
  accessoryUpdateSuccess,
  accessoryUpdateFailure,
  insigniaEnabledMakesFailure,
  insigniaEnabledMakesSuccess,
} from './actions';
import {
  ACCESSORY_CONFIG_REQUEST,
  ACCESSORY_CONFIG_UPDATE_REQUEST,
  ACCESSORY_UPDATE_REQUEST,
  INSIGNIA_ENABLED_REQUEST,
} from './actionTypes';
import AccessoryConfigService from '../../services/AccessoryConfigService';

export function* getAccessoryConfig(action) {
  try {
    const { dealerId } = action.payload;
    const result = yield call(
      AccessoryConfigService.getAccessoryConfig,
      dealerId,
    );
    yield put(accessoryConfigSuccess(result));
  } catch (error) {
    yield put(accessoryConfigFailure(error));
  }
}

export function* updateAccessoryConfig(action) {
  try {
    const { dealerId, accessoryConfig } = action.payload;
    const result = yield call(
      AccessoryConfigService.updateAccessoryConfig,
      dealerId,
      accessoryConfig,
    );
    yield put(accessoryConfigUpdateSuccess(result));
  } catch (error) {
    yield put(accessoryConfigUpdateFailure(error));
  }
}

export function* updateAccessory(action) {
  try {
    const { accessoryId, dealerId, formData } = action.payload;
    yield call(
      AccessoryConfigService.updateAccessory,
      dealerId,
      accessoryId,
      formData,
    );
    yield put(accessoryUpdateSuccess());
    yield put(replace(`/${dealerId}/accessories`));
  } catch (error) {
    yield put(accessoryUpdateFailure(error));
  }
}

export function* insigniaEnabledMakesRequest(action) {
  try {
    const result = yield call(AccessoryConfigService.getInsigniaEnabledMakes);
    yield put(insigniaEnabledMakesSuccess(result));
  } catch (error) {
    yield put(insigniaEnabledMakesFailure(error));
  }
}

export function* accessoryConfigSaga() {
  yield takeEvery(ACCESSORY_CONFIG_REQUEST, getAccessoryConfig);
  yield takeEvery(ACCESSORY_CONFIG_UPDATE_REQUEST, updateAccessoryConfig);
  yield takeEvery(ACCESSORY_UPDATE_REQUEST, updateAccessory);
  yield takeEvery(INSIGNIA_ENABLED_REQUEST, insigniaEnabledMakesRequest);
}
